import {
  DELETE_PADDOCK_API_URL,
  UPSERT_PADDOCK_API_URL,
} from 'constants/apiConstants';
import { IFarmWriteResponse } from 'interfaces/IFarm';
import { IPaddock } from 'interfaces/IPaddock';
import { IZone } from 'interfaces/IZone';
import axiosInstance from 'services/AxiosInstance';

/**
 * Paddocks live inside their Farm document, so every call names the farm and
 * the response carries the updated farm (OP-2481).
 */
export const PaddockService = {
  /**
   * Creates or updates a paddock. The zone is saved in the same call — a new
   * paddock's default zone, or an edited paddock's zone — and is null when the
   * zone doesn't change.
   */
  Upsert: async (
    farmId: string,
    paddock: IPaddock,
    zone: IZone | null
  ): Promise<IFarmWriteResponse> => {
    const response = await axiosInstance.post<IFarmWriteResponse>(
      UPSERT_PADDOCK_API_URL,
      { farmId, paddock, zone },
      { headers: { ClientNow: new Date().toISOString() } }
    );
    return response.data;
  },

  /** Soft-deletes a paddock from its farm. */
  Delete: async (
    farmId: string,
    paddockId: string
  ): Promise<IFarmWriteResponse> => {
    const response = await axiosInstance.delete<IFarmWriteResponse>(
      DELETE_PADDOCK_API_URL,
      {
        data: { farmId, paddockId },
        headers: { ClientNow: new Date().toISOString() },
      }
    );
    return response.data;
  },
};

export default PaddockService;
